var map = {
	"./centos.svg": "e9a8",
	"./coreos.svg": "36cd",
	"./debian.svg": "686b",
	"./freebsd.svg": "42b1",
	"./gentoo.svg": "d9b0",
	"./kylin.svg": "2f8a",
	"./linux.svg": "d978",
	"./nfs.svg": "0248",
	"./redhat.svg": "8514",
	"./suse.svg": "3399",
	"./ubuntu.svg": "8e7d",
	"./unknow.svg": "3141",
	"./virtio.svg": "930b",
	"./windows.svg": "b1b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f5";